import React, {Component, Fragment} from 'react'
import {
    Form, Input, Row, Col, Select, DatePicker, Button, Table, message,
} from 'antd';
import {reqLogisticsList, baseUrl} from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
import moment from 'moment';
import 'moment/locale/zh-cn';
import {convertToOptions} from "../../components/options";
import {
    ORDER_STATUS, LOGISTICS_STATUS, DELIVERY_TYPE, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR
} from "../../utills/constants";
import {getVehicleInfo}from  '../../utills/common'
moment.locale('zh-cn');
const AuthButton = authorizeBase(Button);
const {Option} = Select;

class TrackList extends Component {

    state = {
        total: 0, // 商品的总数量
        orderList: [], // 商品的数组
        pageNum: 1,
        searchData: {},
        selectedRowKeys: [],
        deliveryFromDt: null,
        deliveryToDt: null,
        sortData: {},
        arrow: 'up-arrow',
    }

    /*
     初始化table的列的数组
     */
    initColumns = () => {
        this.columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                sorter: true,
                render: (text, record) => (
                    <a authority="delivery:view"
                       onClick={() => this.props.history.push('/TrackDetail', {orderId: record.id})}>{text}</a>
                )
            },
            {
                title: '揽收单位',
                dataIndex: 'entName',
            },
            {
                title: '起运地',
                sorter: true,
                dataIndex: 'originCity',
                render: (text, record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '出境口岸',
                dataIndex: 'customsPortName',
            }, {
                title: '转关地/清关地/目的机场',
                dataIndex: 'destinationStartCountry',
                render: (text, record) => {
                    if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(record.deliveryType)) {
                        return <span>{record.customsClearanceCountry}&nbsp;{record.customsClearanceCity}</span>
                    }
                    if (DELIVERY_TYPE_AIR.hasOwnProperty(record.deliveryType)) {
                        return <span>{record.customsClearanceCountry}&nbsp;{record.customsClearanceCity}
                            /{record.destinationStartCountry}&nbsp;{record.destinationStartCity}</span>
                    }
                    return <span>{record.destinationStartCountry}&nbsp;{record.destinationStartCity}</span>
                }
            }, {
                title: '目的地',
                sorter: true,
                dataIndex: 'destinationCountry',
                render: (text, record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            }, {
                title: '还箱地',
                sorter: true,
                dataIndex: 'boxReturnStation',
            },
            {
                title: '装箱地',
                dataIndex: 'boxLocation',
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.boxLocation}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            },
            {
                title: '境内车牌',
                dataIndex: 'orderVehicleVo',
                render: (text, record) => (
                    <span>{getVehicleInfo(record.orderVehicleVo.truckNo, record.orderVehicleVo.hangNo)}</span>
                )
            },
            {
                title: '境外车牌 ',
                dataIndex: 'orderVehicleVoOut',
                render: (text, record) => (
                    <span>{getVehicleInfo(record.orderVehicleVoOut.truckNo, record.orderVehicleVoOut.hangNo)}</span>
                )
            },
            {
                title: 'gps编号',
                dataIndex: 'trailNo',
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.trailNo}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
                render: (text, record) => (
                    <span>
                    {record.orderDeliveryVos.map((c, i) => {
                            return <div key={c.id}>
                                {c.boxNo}
                            </div>
                        }
                    )
                    }
                  </span>
                )
            }, {
                title: '预计提货时间',
                sorter: true,
                dataIndex: 'deliveryEstimateDt',
            }, {
                title: '提货时间',
                sorter: true,
                dataIndex: 'deliveryTime',
            }
            ,
            {
                title: '订单状态',
                sorter: true,
                dataIndex: 'orderStatus',
                render: (text, record) => (
                    <span>{ORDER_STATUS[text]}</span>
                )
            }, {
                title: '物流状态',
                sorter: true,
                dataIndex: 'logisticsStatus',
                render: (text, record) => (
                    <span>{LOGISTICS_STATUS[text]}</span>
                )
            }/*, {
             title: '备注说明',
             dataIndex: 'remarks',
             }*/
            // , {
            //     title: '操作',
            //     dataIndex: 'opt',
            //     fixed: 'right',
            //     width: 100,
            //     render: (text, record) => (
            //         <span>
            //         {record.logisticsStatus === 'cancelled'?null:<AuthLinkButton authority="delivery:edit"
            //                            onClick={() => this.props.history.push('/TrackInfo', {orderId: record.id})}>编辑</AuthLinkButton>}
            //          </span>
            //     )
            // }
        ];
    }


    exportModel = () => {
        const {selectedRowKeys, deliveryFromDt, deliveryToDt} = this.state;
        const searchData = this.props.form.getFieldsValue();
        if (!searchData.deliveryType) {
            message.error("导出时, 必须选择运输类型");
            return false;
        }
        const search = [];
        let url;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            url = baseUrl + "/api/v1/p/mms/exportList?ids=" + selectedRowKeys + "&deliveryType=" + searchData.deliveryType;
        } else {
            for (let key of  Object.keys(searchData)) {
                if (searchData[key] != null) {
                    if (key === 'deliveryFromDt') {
                        search.push('&deliveryFromDt' + '=' + deliveryFromDt);
                    }
                    if (key === 'deliveryToDt') {
                        search.push('&deliveryToDt' + '=' + deliveryToDt);
                    } else {
                        search.push('&' + key + '=' + searchData[key])
                    }
                }
            }
            url = baseUrl + "/api/v1/p/mms/exportList?" + search.join('');
        }
        window.open(url, "_blank");
    }

    componentWillMount() {
        this.initColumns()
    }

    getProducts = async (pageNum, sortData) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum,// 保存pageNum, 让其它方法可以看到
            selectedRowKeys: [],
        })
        const {getFieldsValue} = this.props.form
        const searchData = getFieldsValue();
        const {deliveryFromDt, deliveryToDt} = this.state
        searchData.deliveryFromDt = deliveryFromDt;
        searchData.deliveryToDt = deliveryToDt;
        searchData.pageNum = pageNum;
        searchData.pageSize = pageSize;
        if (sortData) {
            searchData.sort = sortData.sort
            searchData.order = sortData.order
        }
        if (!searchData.orderStatus) {
            searchData.notInStatusStr = 'new,audit,failed';
        }
        let result = await reqLogisticsList(searchData)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    handleSubmit = (event) => {
        // 阻止事件的默认行为
        event.preventDefault()
        // 对所有表单字段进行检验
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {sortData} = this.state
            if (err) {
                return;
            }
            this.setState({
                searchData: values
            })
            const {deliveryFromDt, deliveryToDt} = this.state
            values.deliveryFromDt = deliveryFromDt;
            values.deliveryToDt = deliveryToDt;
            this.getProducts(1, sortData);
            values.arrow = this.state.arrow;
            sessionStorage.setItem("trackList", JSON.stringify(values));
        });
    }

    componentDidMount() {
        const orderList = JSON.parse(sessionStorage.getItem("trackList"));
        if (orderList) {
            this.setState({
                arrow: orderList.arrow,
                deliveryFromDt: orderList.deliveryFromDt,
                deliveryToDt: orderList.deliveryToDt
            }, () => {
                this.initFormValue(orderList);
                this.getProducts(1)
            })
        } else {
            this.getProducts(1);
        }
    }

    initFormValue = (orderList) => {
        const {setFieldsValue} = this.props.form;
        const deliveryFromDt = orderList.deliveryFromDt ? moment(orderList.deliveryFromDt, 'YYYY-MM-DD HH:mm:ss') : null;
        const deliveryToDt = orderList.deliveryToDt ? moment(orderList.deliveryToDt, 'YYYY-MM-DD HH:mm:ss') : null;
        setFieldsValue({...orderList, deliveryFromDt, deliveryToDt});
    };


    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryToDt: dateString
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        const pageNum = pagination.current
        const sortData = {
            sort: sorter.field,
            order: sorter.order,
        }
        this.setState({
            sortData
        })
        this.getProducts(pageNum, sortData)
    };
    moreClick = () => {
        const {arrow} = this.state;
        this.setState({
            arrow: arrow === 'down-arrow' ? 'up-arrow' : 'down-arrow'
        })
    };
    handleReset = () => {
        this.props.form.resetFields();
        this.setState({deliveryFromDt: null, deliveryToDt: null});
        sessionStorage.removeItem("trackList");
    }

    render() {

        const form = this.props.form
        const {getFieldDecorator} = form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 8},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 14},
                sm: {span: 14},
            },
        }
        const formItemLayout1 = {
            labelCol: {
                xs: {span: 11},
                sm: {span: 11},
            },
            wrapperCol: {
                xs: {span: 11},
                sm: {span: 11},
            },
        }
        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({selectedRowKeys: selectedRowKeys})
            }
        }

        // 取出状态数据
        const {orderList, total} = this.state

        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>物流信息列表
                    <span className="arrow"
                          onClick={this.moreClick}>{this.state.arrow === 'down-arrow' ? '收起' : '更多'}
                        <span className={this.state.arrow}></span></span></div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="订单编号">
                                {getFieldDecorator('orderNo', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="集装箱号">
                                {getFieldDecorator('boxNo', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="揽收单位">
                                {getFieldDecorator('entName', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        {this.state.arrow === 'down-arrow' ?
                            <Fragment>
                                <Col span={6}>
                                    <Form.Item label="起运地">
                                        {getFieldDecorator('departure', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="转关地/清关地/目的机场">
                                        {getFieldDecorator('transitPoint', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="目的地">
                                        {getFieldDecorator('destination', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="还箱地">
                                        {getFieldDecorator('boxReturnStation', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="订单状态">
                                        {getFieldDecorator('orderStatus', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            {/*<Option value="audited">待订舱</Option>*/}
                                            <Option value="booked">已订舱</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="declare">待报关</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                            <Option value="cancelled">已取消</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="物流状态">
                                        {getFieldDecorator('logisticsStatus', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            <Option value="waiting">待提货</Option>
                                            <Option value="boxed">已装箱</Option>
                                            <Option value="transport">运输中</Option>
                                            <Option value="declaring">报关中</Option>
                                            <Option value="released">已放行</Option>
                                            <Option value="destination">已到达</Option>
                                            <Option value="cancelled">已取消</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="提货时间" className='time-input-to'>
                                        {getFieldDecorator('deliveryFromDt')(<DatePicker
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            onChange={this.onDateChange} style={{width: "110%", minWidth: 10}}
                                        />)}

                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label={"至"} className='time-input-to'>
                                        {getFieldDecorator('deliveryToDt')(<DatePicker
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            onChange={this.onDateChange2} style={{width: "110%", minWidth: 10}}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="GPS编号">
                                        {getFieldDecorator('gpsNo', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="提运单号">
                                        {getFieldDecorator('deliveryNo', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="中车号">
                                        {getFieldDecorator('realPlateNo', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="跨境电商车板号" {...formItemLayout1}>
                                        {getFieldDecorator('virtualPlateNo', {})(<Input />)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="运输类型">
                                        {getFieldDecorator('deliveryType', {
                                            initialValue: '',
                                        })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                            <Option value="">全部</Option>
                                            {convertToOptions(DELIVERY_TYPE)}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="境内车牌">
                                        {getFieldDecorator('truckNo', {})(<Input/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="境外车牌">
                                        {getFieldDecorator('overseaTruckNo', {})(<Input/>)}
                                    </Form.Item>
                                </Col>
                            </Fragment> : null}
                        <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                            <Button htmlType="button" style={{float: 'right', marginLeft: '10px'}}
                                    onClick={this.handleReset}>清空</Button>
                            <Button type='primary' htmlType="submit" style={{float: 'right'}}>查询</Button>
                            <AuthButton authority="delivery:export" type="primary"
                                        onClick={this.exportModel}
                                        style={{float: 'right', marginRight: '10px'}}>导出</AuthButton>
                        </Col>
                    </Row>
                </Form>
                <Table
                    rowSelection={rowSelection}
                    columns={this.columns}
                    dataSource={orderList}
                    rowKey='id'
                    bordered
                    scroll={{x: 2100}}
                    onChange={this.handleTableChange}
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                    }}
                    size="middle"
                />
            </div>

        )
    }
}
const trackListFrom = Form.create()(TrackList)
export default trackListFrom